/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Error_Getting_TranslationsInputs */



/**
* | output |
* | --- |
* | "Error getting translations: {error}" |
*
* @param {Error_Getting_TranslationsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_getting_translations = /** @type {((inputs: Error_Getting_TranslationsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Getting_TranslationsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur lors de la récupération des traductions : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Abrufen der Übersetzungen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore durante il recupero delle traduzioni: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка при получении переводов: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al obtener las traducciones: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`获取翻译时出错：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`翻訳の取得中にエラーが発生しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`अनुवाद प्राप्त करने में त्रुटि: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erro ao obter traduções: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Error getting translations: ${i?.error}`)
});